<template>
  <div>
    <DeleteUserModal v-on:close-modal="closeModal" v-on:delete-user="deleteUser" v-if="deleteActive" />
    <EditUserModal
      v-on:add-admin="addAdmin"
      v-on:remove-admin="removeAdmin"
      v-on:close-edit-modal="closeEditModal"
      :currentUser="currentUser"
      v-if="editActive"
    />
    <div class="container container-dashboard">
      <div class="admin-wrap">
        <div>
          <h2>Users Enrolled into Pediatric Health Consultants:</h2>
        </div>
        <div class="user-grid">
          <div v-for="(user, index) in users" :key="index" class="user">
            <div class="user-type">
              <div v-if="user.isAdmin" class="type admin">
                <i class="fad fa-users-cog"></i>
                <p>Admin</p>
              </div>
            </div>
            <div class="edit-remove">
              <i @click="openEditModal(user, user.id)" class="fad fa-edit"></i>
              <i @click="openDeleteModal(user.id)" class="fad fa-trash"></i>
            </div>
            <div class="img">
              <img v-if="user.profileImg" :src="user.profileImg" alt="" />
              <p v-else>{{ user.initials }}</p>
            </div>
            <div class="information">
              <p class="username">{{ user.fullname }}</p>
              <p class="email">{{ user.email }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import "firebase/auth";
// import "firebase/admin";
import DeleteUserModal from "./DeleteUserModal";
import EditUserModal from "./EditUserModal";
import firebase from "firebase/app";
import db from "../firebase/init";
import "firebase/functions";
import "firebase/auth";

export default {
  name: "Admin",
  components: {
    DeleteUserModal,
    EditUserModal,
  },
  data() {
    return {
      email: null,
      users: [],
      deleteActive: null,
      editActive: null,
      currentUID: null,
      currentUser: null,
    };
  },
  created() {
    this.getUser();
  },
  methods: {
    // cloud function to add admin
    addAdmin() {
      let createAdmin = firebase.functions().httpsCallable("createAdmin");
      createAdmin({ uuid: this.currentUID }).then(() => {
        window.location.reload();
      });
    },
    removeAdmin() {
      let removeAdmin = firebase.functions().httpsCallable("removeAdmin");
      removeAdmin({ uuid: this.currentUID }).then(() => {
        window.location.reload();
      });
    },

    deleteUser() {
      let deleteUserFromAuth = firebase.functions().httpsCallable("deleteUserFromAuth");
      let ref = db.collection("users").doc(this.currentUID);
      deleteUserFromAuth({ uuid: this.currentUID });
      ref.delete();
      this.users = this.users.filter((docus) => {
        return docus.id != this.currentUID;
      });
    },

    closeModal() {
      this.deleteActive = !this.deleteActive;
    },

    openDeleteModal(userId) {
      this.deleteActive = !this.deleteActive;
      this.currentUID = userId;
    },

    openEditModal(user, userId) {
      this.editActive = !this.editActive;
      this.currentUser = user;
      this.currentUID = userId;
      console.log(this.currentUID);
    },

    closeEditModal() {
      this.editActive = !this.editActive;
    },

    getUser() {
      db.collection("users")
        .orderBy("fullname")
        .onSnapshot((snap) => {
          snap.docChanges().forEach((docu) => {
            const name = docu.doc.data().fullname;
            const initials = name
              .match(/(\b\S)?/g)
              .join("")
              .match(/(^\S|\S$)?/g)
              .join("")
              .toUpperCase();
            if (docu.type === "added") {
              // upon loading, all docs will be added
              const data = {
                id: docu.doc.id,
                fullname: docu.doc.data().fullname,
                email: docu.doc.data().email,
                profileImg: docu.doc.data().profileImg,
                isAdmin: docu.doc.data().isAdmin,
                initials: initials,
              };
              this.users.push(data);
            } else if (docu.type === "modifed") {
              const data = {
                id: docu.doc.id,
                fullname: docu.doc.data().fullname,
                email: docu.doc.data().email,
                profileImg: docu.doc.data().profileImg,
                isAdmin: docu.doc.data().isAdmin,
                initials: initials,
              };
              this.users.push(data);
            } else if (docu.type === "removed") {
              this.users = this.users.filter((docus) => {
                return docus.id != docu.doc.id;
              });
            }
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.container-dashboard {
  background-color: #f1f1f1;
}

.admin-wrap {
  padding: 40px 24px;
}

.user-grid {
  margin-top: 40px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 60px;

  .user {
    cursor: pointer;
    position: relative;
    padding: 60px 24px 40px;
    border-radius: 10px;
    text-align: center;
    background-color: white;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
  }

  .img {
    display: flex;
    justify-content: center;

    p {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 50px;
      width: 50px;
      border-radius: 50%;
      color: white;
      background-color: #6338ff;
      box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
    }
  }

  .username {
    margin-top: 8px;
    font-size: 18px;
  }

  .email {
    font-weight: 300;
    font-size: 16px;
  }

  .edit-remove {
    position: absolute;
    top: 16px;
    right: 16px;
    font-size: 16px;

    .fa-edit {
      margin-right: 12px;
      color: #6338ff;
    }

    .fa-trash {
      color: red;
    }
  }

  .user-type {
    top: 16px;
    left: 16px;
    position: absolute;
    display: inline-block;
    font-size: 13px;
    border-radius: 8px;
    background-color: #6338ff;
    color: white;

    i {
      margin-right: 8px;
    }

    .type {
      padding: 4px 8px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .standard {
      background-color: #32c5ff;
      border-radius: 8px;
    }
  }
}
</style>
